<template>
  <v-card color="secondary">
    <v-menu offset-y max-width="100%" :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <div :style="insets && insets.top > 0 ? main : ''">
          <v-text-field
            v-model="text"
            solo
            hide-details
            label="Search"
            append-icon="mdi-magnify"
            @keyup.enter="onSearch"
            v-bind="attrs"
            v-on="on"
            clearable
            color="secondary"
          >
            <template v-slot:prepend-inner>
              <v-icon class="pr-4" @click="$emit('close')" size="20"
                >mdi-arrow-left</v-icon
              >
            </template>
            <template v-slot:append>
              <v-icon class="pr-4" @click="onSearch">mdi-magnify</v-icon>
            </template>

            <template v-slot:label>
              <span class="font-italic body-2 pl-4">
                {{ $t("general.search") }}
              </span>
            </template>
          </v-text-field>
        </div>
      </template>
    </v-menu>

    <v-card-text class="pt-4" style="z-index: 999">
      <div
        v-if="loader"
        class="d-flex flex-column align-center justify-center flex-grow-1"
        style="height: 500px"
      >
        <v-progress-circular indeterminate color="white" size="60">
        </v-progress-circular>
      </div>

      <div
        v-for="(poi, i) in pois"
        :key="i"
        class="d-flex flex-column mb-4"
        style="width: 100%"
      >
        <div
          @click="
            $router.push(`/islands/area/${poi.area_id}/pois/${poi.id}/map`);
            $emit('close');
          "
          class="d-flex justify-center align-center route font-weight-thin body-1 mb-2"
        >
          <v-card width="85vw" style="border-radius: 15px">
            <v-img
              width="100%"
              height="150px"
              v-if="poi.images.length != 0"
              :src="
                'https://api.e-naxios.com/images/' +
                poi.images[0].image[0].file_name
              "
            ></v-img>
            <div
              v-else
              style="width: 100%; height: 150px"
              class="d-flex align-center justify-center"
            >
              <v-icon size="100" color="secondary">
                mdi-image-off-outline
              </v-icon>
            </div>
            <div
              class="secondary--text body-2 font-weigth-regular category ml-6 pt-2"
              style="font-size: 12px"
            >
              {{ poiCategory(poi.category_id).name }}
            </div>
            <div class="secondary--text body-1 font-weight-bold ml-6 pb-2">
              {{ poi.name }}
            </div>
          </v-card>
        </div>
      </div>
      <div v-if="$route.path.split('/')[2] == 'area'" class="mb-10"></div>

      <div v-if="pois.length == 0 && !loader" class="white--text">
        {{ $t("error_messages.no_pois") }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  props: ["name"],

  async created() {
    if (this.name != null) {
      this.text = this.name;
      await this.onSearch();
    }
  },
  data() {
    return {
      loader: false,
      pois: [],
      text: null,
    };
  },

  computed: {
    ...mapState({
      categories: (state) => state.pois.categories,
      insets: (state) => state.base.insets,
    }),

    main() {
      return {
        padding: `${this.insets?.top}px 0px 0px 0px`,
      };
    },

    filters() {
      return [
        {
          label: this.$t("menu.islands"),
          value: null,
        },
        {
          label: this.$t("menu.pois"),
          value: null,
        },
        {
          label: this.$t("menu.routes"),
          value: null,
        },
      ];
    },
  },

  methods: {
    poiCategory(category_id) {
      return this.categories.find((el) => el.id == category_id);
    },

    async onSearch() {
      this.pois = [];
      this.loader = true;
      const res = await axios.get(`${process.env.VUE_APP_BASE_URL}/pois`, {
        params: {
          name: this.text,
        },
      });

      this.pois = res.data;
      this.loader = false;
    },
  },
};
</script>

<style scoped lang="scss">
.v-menu__content {
  width: 100% !important;
  border-radius: 0px !important;
}

.category::before {
  content: "";
  position: absolute;
  left: 0;
  margin-top: 8px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;

  width: 12px;
  height: 5px;
  background: var(--v-accent-base);
}
</style>
